module.exports = __webpack_public_path__ + "img/pen-tool-plus.5c65f1d0.svg";